export default "__VITE_ASSET__32dbbe76__"